import { render, staticRenderFns } from "./RmpDetailsItemLoader.vue?vue&type=template&id=035dc391"
import script from "./RmpDetailsItemLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpDetailsItemLoader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports